import messageResource from '../messageResource'

export const formatLFMU = function ( firstName, lastName, middleName, username, lastFirstNamesSeparator )
{
    return formatLFM( firstName, lastName, middleName, lastFirstNamesSeparator ) + " (" + username + ")";
};

export const formatLFM = function ( firstName, lastName, middleName, lastFirstNamesSeparator )
{
    const separator =  lastFirstNamesSeparator ? lastFirstNamesSeparator : ", ";
    let result = lastName + separator + firstName;
    if( middleName )
        result += " " + middleName + ".";
    return result;
};

export const formatFML = function ( firstName, lastName, middleName )
{
    let result = firstName;
    if( middleName )
        result += " " + middleName + ".";
    return result + " " + lastName;
};

export const formatFMLU = function ( firstName, lastName, middleName, username )
{
    return formatFML( firstName, lastName, middleName ) + " (" + username + ")";
};

export const formatFmlWithCheck = function({firstName, middleInitial, lastName}) {
    if (firstName && lastName) return formatFML(firstName, lastName, middleInitial)
    if (firstName) return firstName
    if (lastName) {
        let result = ""
        if (middleInitial) result += middleInitial + ". "
        result += lastName
        return result
    }
    return messageResource.getMessage('user.singular')
}

export const formatFL = function({firstName, lastName}) {
    return firstName + ' ' + lastName
}

export default {
    formatLFMU,
    formatLFM,
    formatFML,
    formatFMLU,
    formatFL
};


// WEBPACK FOOTER //
// ./web/js/util/UserNameFormat.js